import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import store, { history } from './store'
import App from './containers/App'

import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import './index.css'

import WebFont from 'webfontloader';


WebFont.load({
  google: {
    families: ['Roboto:100,300,400,500,500i,700', 'sans-serif']
  }
});

const target = document.querySelector('#root')

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
        <App />
    </ConnectedRouter>
  </Provider>,
  target
)



// WEBPACK FOOTER //
// ./src/index.js